import React, { useState } from "react";
import { SheetBody, SheetFooter, SheetTitle } from "../ui/SheetHost";

/* FilterSheet (design 2b) — large sheet. Provider + game-type chips toggle, a
   sort radio, and the footer CTA applies. Provider slots stay DASHED ("Provider
   TBD") until a real slots provider is contracted (honest). Returns the selected
   filters to the lobby via onApply. Live providers (Kerma/JackTop) show as real
   chips when present. */

const Chip = ({ label, on, dashed, onClick }) => (
  <button
    type="button" onClick={onClick} aria-pressed={on} disabled={dashed}
    style={{
      height: 36, padding: "0 14px", borderRadius: 12, border: 0, cursor: dashed ? "default" : "pointer",
      font: `${on ? 700 : 600} 13px 'Outfit'`,
      background: on ? "#F4F4F5" : dashed ? "transparent" : "#18181C",
      color: on ? "#0A0A0A" : dashed ? "#52525b" : "#D4D4D8",
      boxShadow: on ? "none" : dashed ? "inset 0 0 0 1px" : "inset 0 0 0 1px #26262B",
      outline: dashed ? "1px dashed #3F3F46" : "none", outlineOffset: dashed ? -1 : 0,
    }}
  >
    {label}
  </button>
);

const Radio = ({ label, on, onClick }) => (
  <button type="button" onClick={onClick} aria-pressed={on}
    style={{ display: "flex", alignItems: "center", gap: 12, width: "100%", padding: "12px 2px", background: "none", border: 0, cursor: "pointer", textAlign: "left" }}>
    <span style={{ width: 20, height: 20, flex: "none", borderRadius: "50%", boxShadow: on ? "inset 0 0 0 1.5px #00D632" : "inset 0 0 0 1px #3F3F46", background: on ? "rgba(0,214,50,.07)" : "transparent", display: "flex", alignItems: "center", justifyContent: "center" }}>
      {on && <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#00D632" }} />}
    </span>
    <span style={{ font: "600 15px 'Outfit'", color: "#fff" }}>{label}</span>
  </button>
);

const Section = ({ label, children }) => (
  <div style={{ marginBottom: 18 }}>
    <div style={{ font: "700 11px 'Outfit'", letterSpacing: ".16em", color: "#71717a", marginBottom: 10 }}>{label}</div>
    {children}
  </div>
);

export default function FilterSheet({ close, providers = [], initial = {}, onApply }) {
  // Real live providers (Kerma/JackTop/…) become real chips; pad with dashed TBD
  // up to 4 provider slots so the row reads like the mockup without fabricating.
  const realProviders = ["Originals", "Live Studio", ...providers.filter((p) => p && !["pnrbet", "pnr"].includes(p)).map((p) => p[0].toUpperCase() + p.slice(1))];
  const uniqueProv = [...new Set(realProviders)];
  const tbdCount = Math.max(0, 4 - uniqueProv.length);

  const [prov, setProv] = useState(new Set(initial.prov || []));
  const [types, setTypes] = useState(new Set(initial.types || []));
  const [sort, setSort] = useState(initial.sort || "recent");

  const toggle = (set, setter, v) => { const n = new Set(set); n.has(v) ? n.delete(v) : n.add(v); setter(n); };

  const SORTS = [["az", "A–Z"], ["recent", "Recently played"], ["added", "Recently added"]];
  const TYPES = ["Slots", "Table games", "Live dealer", "Instant"];

  return (
    <>
      <SheetTitle>Filter games</SheetTitle>
      <SheetBody>
        <Section label="PROVIDER">
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {uniqueProv.map((p) => <Chip key={p} label={p} on={prov.has(p)} onClick={() => toggle(prov, setProv, p)} />)}
            {Array.from({ length: tbdCount }).map((_, i) => <Chip key={`tbd${i}`} label="Provider TBD" dashed />)}
          </div>
        </Section>
        <Section label="GAME TYPE">
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {TYPES.map((t) => <Chip key={t} label={t} on={types.has(t)} onClick={() => toggle(types, setTypes, t)} />)}
          </div>
        </Section>
        <Section label="SORT BY">
          {SORTS.map(([id, l]) => <Radio key={id} label={l} on={sort === id} onClick={() => setSort(id)} />)}
        </Section>
      </SheetBody>
      <SheetFooter>
        <div style={{ display: "flex", gap: 10 }}>
          <button type="button" onClick={() => { setProv(new Set()); setTypes(new Set()); setSort("recent"); }}
            style={{ flex: "none", width: 110, height: 52, borderRadius: 15, background: "#141417", color: "#fff", font: "700 14px 'Outfit'", border: 0, cursor: "pointer", boxShadow: "inset 0 0 0 1px #2F2F35" }}>
            Clear
          </button>
          <button type="button" onClick={() => { onApply?.({ prov: [...prov], types: [...types], sort }); close(); }}
            style={{ flex: 1, height: 52, borderRadius: 15, background: "#00D632", color: "#0A0A0A", font: "800 15px 'Manrope'", border: 0, cursor: "pointer", boxShadow: "inset 0 1px 0 rgba(255,255,255,.3)" }}>
            Show games
          </button>
        </div>
      </SheetFooter>
    </>
  );
}
